import React, { useEffect, useState } from "react";
import "../assets/scss/pages/_sidebar.scss";
import PropTypes from "prop-types";
//import Components
import { Link, useLocation, useNavigate } from "react-router-dom";
// import mainLogo from "../assets/images/casp-main-logo.png";
import devLogo from "../assets/images/PST-logo.png";
import stageLogo from "../assets/images/KVP-logo1.svg";
import stageminiLogo from "../assets/images/kvp-logo-small.png";
import devminiLogo from "../assets/images/pst-logo-small.svg";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { styled, useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import ListItemButton from "@mui/material/ListItemButton";
import Collapse from "@mui/material/Collapse";
import { BusinessCenter, ExpandLess, ExpandMore, TaskAltOutlined, TodayOutlined } from "@mui/icons-material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import InsertChartOutlinedOutlinedIcon from "@mui/icons-material/InsertChartOutlinedOutlined";
import ApprovalIcon from "@mui/icons-material/Approval";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { useDispatch, useSelector } from "react-redux";
import { Role } from "../constants/Role";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { withTranslation } from "react-i18next";
import withRouter from "../Components/Common/withRouter";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import CaspMiniLogo from "../assets/images/casp-logo-small.svg";
import ChangeCircleOutlinedIcon from "@mui/icons-material/ChangeCircleOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import EmojiFlagsOutlinedIcon from "@mui/icons-material/EmojiFlagsOutlined";
import EmojiFlagsIcon from "@mui/icons-material/EmojiFlags";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import AppRegistrationOutlinedIcon from "@mui/icons-material/AppRegistrationOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import ContentPasteGoOutlinedIcon from "@mui/icons-material/ContentPasteGoOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import { ProjectStatuses } from "../constants/Status";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import ViewAgendaOutlinedIcon from "@mui/icons-material/ViewAgendaOutlined";
import ViewQuiltOutlinedIcon from "@mui/icons-material/ViewQuiltOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";

const MainSidebar = (props) => {
  const currentProjectRole = useSelector(
    (state) => state.Roles.currentProjectRole
  );
  const loggedInUser = useSelector((state) => state.Profile.user);
  const isCompanySpecific = ['NTDP', 'JST','RCT'].includes(loggedInUser.company?.name)
  const location = useLocation();
  const { pathname } = location;

  const [logoLink, setLogoLink] = useState("");
  const [miniVariant, setMiniVariant] = useState(false);
  const [selectUniqueId, setSelectUniqueId] = useState();
  const [trigger, setTrigger] = useState(+new Date());
  // const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  // const theme = useTheme();

  const initialMenu = [
    {
      id: "projectSettings",
      label: props.t("Dashboard"),
      icon: <SettingsOutlinedIcon />,
      link: `/project-dashboard`,
      uniqueId: 1,
    },
    {
      id: "calendar",
      label: props.t("Calendar"),
      icon: <InsertChartOutlinedOutlinedIcon />,
      link: `/calendar`,
      uniqueId: 2,
    },
    {
      uniqueId: 16,
      id: "agenda",
      label: "Courses & Agenda",
      icon: <TodayOutlined />,
      link: `/to-do-list`,
    },
    // {
    //   uniqueId: 31,
    //   id: "all-actions",
    //   label: "All Actions",
    //   icon: <PostAddOutlinedIcon />,
    //   link: "/all-actions",
    // },
  ];

  const recursiveChildrenActive = (item) => {
    if (selectUniqueId && item?.uniqueId && item.uniqueId === selectUniqueId) {
      return true;
    } else if (!selectUniqueId && item?.link && item.link === pathname) {
      return true;
    } else {
      if (item?.children && item.children.length > 0) {
        const newChildren = item.children.map((child) =>
          recursiveChildrenActive(child)
        );
        return newChildren.includes(true);
      } else {
        return false;
      }
    }
  };
  const matchStageEnv = /\bstage\b/i;
  const recursiveChildrenActiveLink = (item) => {
    if (item?.link && item.link === pathname) {
      return true;
    } else {
      if (item?.children && item.children.length > 0) {
        const newChildren = item.children.map((child) =>
          recursiveChildrenActiveLink(child)
        );
        return newChildren.includes(true);
      } else {
        return false;
      }
    }
  };

  const toggleMiniVariant = () => {
    setMiniVariant(!miniVariant);
  };
  // const toggleSidebarCollapse = () => {
  //   setIsSidebarCollapsed(!isSidebarCollapsed);
  // };
  const [menu, setMenu] = useState({
    menu: [...initialMenu],
    openItems: [],
  });

  useEffect(() => {
    const { role, project } = currentProjectRole ?? {
      role: null,
      project: null,
    };
    let newIsFixed = false;
    if (currentProjectRole?.role) {
      newIsFixed = [Role.EPMO_OFFICER, Role.PORTFOLIO_MANAGER, Role.MENTOR].includes(
        currentProjectRole?.role
      );
    }

    if (!project && !newIsFixed) {
      setMenu({
        menu: [...initialMenu],
        openItems: [],
      });
    } else {
      switch (role) {
        case Role.EPMO_OFFICER:
          setMenu((prev) => ({
            menu: [
              ...[
                {
                  uniqueId: 1,
                  id: "projectSettings",
                  label: "Home Page",
                  icon: <DashboardOutlinedIcon />,
                  link: `/projects`,
                },
                // {
                //   uniqueId: 3,
                //   id: "management",
                //   label: props.t("Overview"),
                //   icon: <PostAddOutlinedIcon />,
                //   //link: "/#",
                //   children: [
                //     {
                //       uniqueId: 4,
                //       id: "overview",
                //       label: props.t("Milestone"),
                //       link: "/milestone-overview",
                //       parentId: "management",
                //       icon: <EmojiFlagsIcon />,
                //     },
                //     // {
                //     //   uniqueId: 5,
                //     //   id: "overview",
                //     //   label: "Projects",
                //     //   parentId: "management",
                //     //   icon: <AccountTreeOutlinedIcon />,
                //     //   children: [
                //     //     {
                //     //       id: "ongoingProject",
                //     //       label: "Ongoing Projects",
                //     //       link: `/ongoing-projects`,
                //     //       icon: <ContentPasteGoOutlinedIcon />,
                //     //       parentId: "projects",
                //     //     },
                //     //     {
                //     //       uniqueId: 6,
                //     //       id: "pendingProject",
                //     //       label: "Pending Projects",
                //     //       link: `/pending-projects`,
                //     //       parentId: "projects",
                //     //       icon: <PendingActionsOutlinedIcon />,
                //     //     },
                //     //   ],
                //     // },
                //     {
                //       uniqueId: 7,
                //       id: "overview",
                //       label: props.t("Risk Register"),
                //       link: "/risk-register-overview",
                //       parentId: "management",
                //       icon: <AppRegistrationOutlinedIcon />
                //     },
                //   ],
                // },
                {
                  id: "projectSettings",
                  label: "Dashboard",
                  icon: <SettingsOutlinedIcon />,
                  link: `/project-dashboard-new`,
                },
                {
                  uniqueId: 16,
                  id: "agenda",
                  label: "Courses & Agenda",
                  icon: <TodayOutlined />,
                  link: `/to-do-list`,
                },
                {
                  uniqueId: 8,
                  id: "actions",
                  label: "Startup Actions",
                  icon: <PostAddOutlinedIcon />,
                  children: [
                    {
                      uniqueId: 6,
                      id: "pendingProject",
                      label: "Pending Startups",
                      link: `/pending-projects`,
                      parentId: "actions",
                      icon: <PendingActionsOutlinedIcon />,
                    },
                    {
                      uniqueId: 2,
                      id: "ongoingProject",
                      label: "Ongoing Startups",
                      link: `/ongoing-projects`,
                      icon: <ContentPasteGoOutlinedIcon />,
                      parentId: "actions",
                    },
                    loggedInUser?.email === 'codingvalley@hotmail.com' ? null :
                    {
                      uniqueId: 9,
                      id: "project-approval",
                      label: "Startups Waiting for Approval",
                      link: `/project-approval`,
                      parentId: "actions",
                      icon: <AccountTreeOutlinedIcon />,
                    },
                    {
                      uniqueId: 11,
                      id: "project-submission-done",
                      label: "Graduated Startups",
                      link: `/project-submission-done`,
                      parentId: "actions",
                      icon: <AccountTreeOutlinedIcon />,
                    },
                    // {
                    //   ...(isCompanySpecific &&
                    //     project && {
                    //       uniqueId: 20,
                    //       id: "change-request-approval",
                    //       label: "Change Request Approval",
                    //       link: `/project/${project?.id}/change-request-approval`,
                    //       parentId: "actions",
                    //       icon: <ChangeCircleOutlinedIcon />,
                    //     }),
                    // },
                    // {
                    //   ...(isCompanySpecific &&
                    //     project && {
                    //       uniqueId: 21,
                    //       id: "nestablelist",
                    //       label: "Milestone Submission",
                    //       link: `/project/${project?.id}/milestone-submission-done`,
                    //       parentId: "actions",
                    //       icon: <EmojiFlagsOutlinedIcon />,
                    //     }),
                    // },
                    // {
                    //   ...(isCompanySpecific &&
                    //     project && {
                    //     uniqueId: 22,
                    //     id: "nestablelist",
                    //     label: "Deliverable Submission",
                    //     link: `/project/${project?.id}/deliverable-submission-done`,
                    //     parentId: "actions",
                    //     icon: <EmojiFlagsOutlinedIcon />,
                    //   }),
                    // },
                  ],
                },
                // {
                //   uniqueId: 10,
                //   id: "submission",
                //   label: "Submission",
                //   icon: <AssignmentTurnedInOutlinedIcon />,
                //   children: [
                //     {
                //       uniqueId: 11,
                //       id: "project-submission-done",
                //       label: "Projects",
                //       link: `/project-submission-done`,
                //       parentId: "submission",
                //       icon: <AccountTreeOutlinedIcon />,
                //     },
                //   ],
                // },
                {
                  uniqueId: 2,
                  id: "calendar",
                  label: "Calendar",
                  icon: <ViewAgendaOutlinedIcon />,
                  link: `/calendar`,
                },
                {
                  uniqueId: 3,
                  id: "attendance",
                  label: "Attendance",
                  icon: <ViewAgendaOutlinedIcon />,
                  link: `/attendance`,
                },
                loggedInUser?.email === 'codingvalley@hotmail.com' ? null :
                {
                  uniqueId: 31,
                  id: "all-actions",
                  label: "All Actions",
                  icon: <PostAddOutlinedIcon />,
                  link: "/all-actions",
                },
                // {
                //   uniqueId: 12,
                //   id: "userManagement",
                //   label: "User Management",
                //   icon: <PeopleAltOutlinedIcon />,
                //   children: [
                //     {
                //       uniqueId: 13,
                //       id: "user",
                //       label: "User",
                //       link: "/user-list",
                //       parentId: "userManagement",
                //       icon: <PersonOutlineOutlinedIcon/>,
                //     }
                //   ],
                // },
                // {
                //   uniqueId: 14,
                //   id: "apps",
                //   label: "Portfolio",
                //   icon: <ViewQuiltOutlinedIcon />,
                //   link: "/portfolio",
                // },
                {
                  uniqueId: 28,
                  id: "projects",
                  label: "Startup List",
                  icon: <DashboardIcon />,
                  link: "/all-projects",
                },
                {
                  uniqueId: 29,
                  id: "documents",
                  // label: "Document",
                  label: "Startup Files",
                  icon: <StickyNote2Icon />,
                  link: "/all-documents",
                },
                {
                  uniqueId: 33,
                  id: "legal-documents",
                  label: "Legal Documents",
                  icon: <StickyNote2Icon />,
                  link: "/legal-documents",
                },
                {
                  uniqueId: 34,
                  id: "deliverables",
                  label: "Deliverables",
                  icon: <StickyNote2Icon />,
                  link: "/deliverables",
                },
                // {
                //   uniqueId: 28,
                //   id: "projects",
                //   label: "Startup assessment List",
                //   icon: <DashboardIcon />,
                //   link: "/startup-assessment-list",
                // },
                {
                  uniqueId: 15,
                  id: "settings",
                  label: "Settings",
                  icon: <SettingsOutlinedIcon />,
                  children: [
                    {
                      uniqueId: 13,
                      id: "user",
                      label: "Users",
                      link: "/user-list",
                      parentId: "settings",
                      icon: <PersonOutlineOutlinedIcon />,
                    },
                    {
                      uniqueId: 30,
                      id: "deliverables",
                      label: "Deliverables Settings",
                      icon: <FactCheckOutlinedIcon />,
                      link: "/all-deliverables",
                    },
                    // {
                    //   uniqueId: 32,
                    //   id: "project",
                    //   label: "Startup Timeline",
                    //   link: "/project-timeline",
                    //   parentId: "settings",
                    //   icon: <AccountTreeOutlinedIcon />,
                    // },
                    {
                      uniqueId: 35,
                      id: "cohort",
                      label: "Cohort Settings",
                      link: "/all-cohorts",
                      parentId: "settings",
                      icon: <BusinessCenter />,
                    },
                    // {
                    //   uniqueId: 14,
                    //   id: "apps",
                    //   label: "Incubator",
                    //   icon: <ViewQuiltOutlinedIcon />,
                    //   link: "/incubator",
                    // },
                    // {
                    //   uniqueId: 16,
                    //   id: "chat",
                    //   label: "Startup Type",
                    //   link: "/project-type",
                    //   parentId: "settings",
                    //   icon: <AccountTreeOutlinedIcon />,
                    // },
                  ],
                },
                // {
                //   uniqueId: 17,
                //   id: "strategies",
                //   label: "Strategies",
                //   icon: <LightbulbOutlinedIcon />,
                //   children: [
                //     {
                //       uniqueId: 18,
                //       id: "initiative",
                //       label: "Initiative",
                //       link: "/strategy-list",
                //       parentId: "strategies",
                //       icon: <PsychologyOutlinedIcon />
                //     },
                //     {
                //       id: "kpi",
                //       label: "KPIs",
                //       link: "/",
                //       parentId: "strategies",
                //     }
                //   ],
                // }
              ],
            ],
            openItems: [...prev.openItems],
          }));
          break;
        case Role.PORTFOLIO_MANAGER:
          setMenu((prev) => ({
            menu: [
              ...[
                {
                  uniqueId: 1,
                  id: "projectSettings",
                  label: "Dashboard",
                  icon: <SettingsOutlinedIcon />,
                  link: "/project-dashboard",
                },
                {
                  uniqueId: 8,
                  id: "actions",
                  label: "Actions",
                  icon: <ApprovalIcon />,
                  children: [
                    {
                      uniqueId: 9,
                      id: "project-approval",
                      label: "Startups Waiting for Approval",
                      link: `/project/${project?.id}/project-approval`,
                      parentId: "actions",
                      icon: <AccountTreeOutlinedIcon />,
                    },
                    {
                      uniqueId: 11,
                      id: "project-submission-done",
                      label: "Graduated Startups",
                      link: `/project/${project?.id}/project-submission-done`,
                      parentId: "actions",
                      icon: <AccountTreeOutlinedIcon />,
                    },
                    // {
                    //   ...(isCompanySpecific &&
                    //     project && {
                    //     uniqueId: 20,
                    //     id: "change-request-approval",
                    //     label: "Change Request Approval",
                    //     link: `/project/${project?.id}/change-request-approval`,
                    //     parentId: "actions",
                    //     icon: <ChangeCircleOutlinedIcon />,
                    //   }),
                    // },
                    {
                      ...(isCompanySpecific &&
                        project && {
                        uniqueId: 21,
                        id: "nestablelist",
                        label: "Milestone Submission",
                        link: `/project/${project?.id}/milestone-submission-done`,
                        parentId: "actions",
                        icon: <EmojiFlagsOutlinedIcon />,
                      }),
                    },
                    // {
                    //   ...(isCompanySpecific &&
                    //     project && {
                    //     uniqueId: 22,
                    //     id: "nestablelist",
                    //     label: "Deliverable Submission",
                    //     link: `/project/${project?.id}/deliverable-submission-done`,
                    //     parentId: "actions",
                    //     icon: <EmojiFlagsOutlinedIcon />,
                    //   }),
                    // },
                  ],
                },
                // {
                //   uniqueId: 10,
                //   id: "submission",
                //   label: "Submission",
                //   icon: <DoneAllIcon />,
                //   children: [
                //     {
                //       uniqueId: 11,
                //       id: "project-submission-done",
                //       label: "Projects",
                //       link: `/project/${project?.id}/project-submission-done`,
                //       parentId: "submission",
                //       icon: <AccountTreeOutlinedIcon />,
                //     },
                //   ],
                // },
                {
                  uniqueId: 2,
                  id: "calendar",
                  label: "Calendar",
                  icon: <InsertChartOutlinedOutlinedIcon />,
                  link: `/calendar`,
                },
                {
                  uniqueId: 31,
                  id: "all-actions",
                  label: "All Actions",
                  icon: <PostAddOutlinedIcon />,
                  link: "/all-actions",
                },
              ],
            ],
            openItems: [...prev.openItems],
          }));
          break;
        case Role.PROJECT_OWNER:
        case Role.PROJECT_SPONSOR:
          setMenu((prev) => ({
            menu: [
              ...[
                {
                  uniqueId: 1,
                  id: "projectSettings",
                  label: "Dashboard",
                  icon: <SettingsOutlinedIcon />,
                  link: "/project-dashboard",
                },
                {
                  uniqueId: 19,
                  id: "project-individual-dashboard",
                  label: "Startup Dashboard",
                  link: `/project/${project?.id}/dashboard`,
                  icon: <DashboardIcon />,
                },
                {
                  uniqueId: 20,
                  id: "project-detail",
                  label: "Startup Details",
                  link: `/project/${project?.id}/details`,
                  icon: <DashboardOutlinedIcon />,
                },
                {
                  uniqueId: 8,
                  id: "actions",
                  label: "Actions",
                  icon: <ApprovalIcon />,
                  children: [
                    {
                      uniqueId: 9,
                      id: "project-approval",
                      label: "Startups Waiting for Approval",
                      link: `/project/${project?.id}/project-approval`,
                      parentId: "actions",
                      icon: <AccountTreeOutlinedIcon />,
                    },
                    // {
                    //   uniqueId: 20,
                    //   id: "change-request-approval",
                    //   label: "Change Request Approval",
                    //   link: `/project/${project?.id}/change-request-approval`,
                    //   parentId: "actions",
                    //   icon: <ChangeCircleOutlinedIcon />,
                    // },
                    {
                      uniqueId: 11,
                      id: "project-submission-done",
                      label: "Graduated Startups",
                      link: `/project/${project?.id}/project-submission-done`,
                      parentId: "actions",
                      icon: <AccountTreeOutlinedIcon />,
                    },
                    {
                      uniqueId: 21,
                      id: "nestablelist",
                      label: "Milestone Submission",
                      link: `/project/${project?.id}/milestone-submission-done`,
                      parentId: "actions",
                      icon: <EmojiFlagsOutlinedIcon />,
                    },
                    // {
                    //   uniqueId: 22,
                    //   id: "nestablelist",
                    //   label: "Deliverable Submission",
                    //   link: `/project/${project?.id}/deliverable-submission-done`,
                    //   parentId: "actions",
                    //   icon: <EmojiFlagsOutlinedIcon />,
                    // },
                  ],
                },
                // {
                //   uniqueId: 10,
                //   id: "submission",
                //   label: "Submission",
                //   icon: <DoneAllIcon />,
                //   children: [
                //     {
                //       uniqueId: 11,
                //       id: "project-submission-done",
                //       label: "Project Submission",
                //       link: `/project/${project?.id}/project-submission-done`,
                //       parentId: "submission",
                //       icon: <AccountTreeOutlinedIcon/>
                //     },
                //     {
                //       uniqueId: 21,
                //       id: "nestablelist",
                //       label: "Milestone Submission",
                //       link: `/project/${project?.id}/milestone-submission-done`,
                //       parentId: "management",
                //       icon: <EmojiFlagsOutlinedIcon/>
                //     },
                //     {
                //       uniqueId: 22,
                //       id: "nestablelist",
                //       label: "Deliverable Submission",
                //       link: `/project/${project?.id}/deliverable-submission-done`,
                //       parentId: "management",
                //       icon: <EmojiFlagsOutlinedIcon />
                //     },
                //   ],
                // },
                {
                  uniqueId: 2,
                  id: "calendar",
                  label: "Calendar",
                  icon: <InsertChartOutlinedOutlinedIcon />,
                  link: `/calendar`,
                },
                {
                  uniqueId: 31,
                  id: "all-actions",
                  label: "All Actions",
                  icon: <PostAddOutlinedIcon />,
                  link: "/all-actions",
                },
              ],
            ],
            openItems: [...prev.openItems],
          }));
          break;
        case Role.PROJECT_MANAGER: {
          const _menu = [
            {
              uniqueId: 1,
              id: "projectSettings",
              label: "Dashboard",
              icon: <SettingsOutlinedIcon />,
              link: "/project-dashboard",
            },
            // {
            //   uniqueId: 23,
            //   id: "advanceUi",
            //   label: "Startups",
            //   icon: <DashboardOutlinedIcon />,
            //   //link: "/",
            //   children: [
            //     {
            //       uniqueId: 19,
            //       id: "project-individual-dashboard",
            //       label: "Startup Dashboard",
            //       link: `/project/${project?.id}/dashboard`,
            //       parentId: "project",
            //       icon: <AccountTreeOutlinedIcon />,
            //     },
            //     {
            //       uniqueId: 20,
            //       id: "project-detail",
            //       label: "Startup Details",
            //       link: `/project/${project?.id}/details`,
            //       parentId: "project",
            //       icon: <DashboardOutlinedIcon />,
            //     },
            //     // ...![ProjectStatuses.DRAFT].includes(currentProjectRole?.project?.status) ? [{
            //     {
            //       uniqueId: 24,
            //       id: "project-kanban-board",
            //       label: "Kanban Board",
            //       link: `/project/${project?.id}/kanban-board`,
            //       parentId: "project",
            //       icon: <DashboardIcon />,
            //     },
            //     // {
            //     //   id: "risk-status",
            //     //   label: "Risk Status",
            //     //   link: `/project/${project?.id}/risk-status-page`,
            //     //   parentId: "project",
            //     //   icon: <NetworkCheckOutlinedIcon />
            //     // },
            //   ],
            // },
            {
              uniqueId: 2,
              id: "calendar",
              label: "Calendar",
              icon: <InsertChartOutlinedOutlinedIcon />,
              link: `/calendar`,
            },
            {
              uniqueId: 3,
              id: "agenda",
              label: "Courses & Agenda",
              icon: <TodayOutlined />,
              link: `/to-do-list`,
            },
          ];

          // if (
          //   ![
          //     ProjectStatuses.DRAFT,
          //     ProjectStatuses.IN_APPROVAL,
          //     ProjectStatuses.REJECTED,
          //   ].includes(currentProjectRole?.project?.status)
          // ) {
          //   _menu.splice(1, 0, {
          //     uniqueId: 25,
          //     id: "changeRequest",
          //     label: "Change Request",
          //     icon: <PublishedWithChangesIcon />,
          //     //link: "/",
          //     children: [
          //       {
          //         uniqueId: 26,
          //         id: "create-change-request",
          //         label: "Create Change Request",
          //         link: `/project/${project?.id}/create-change-request`,
          //         parentId: "projects",
          //         icon: <ChangeCircleOutlinedIcon />,
          //       },
          //       {
          //         uniqueId: 27,
          //         id: "change-request-list",
          //         label: "Change Request List",
          //         link: `/project/${project?.id}/change-request-list`,
          //         parentId: "projects",
          //         icon: <ChangeCircleOutlinedIcon />,
          //       },
          //     ],
          //   });
          // }
          setMenu((prev) => ({
            menu: [..._menu],
            openItems: [...prev.openItems],
          }));
          break;
        }
        case null:
          setMenu({
            menu: [...initialMenu],
            openItems: [],
          });
          break;
        case Role.MEMBER:
          setMenu((prev) => ({
            menu: [
              ...[
                {
                  uniqueId: 1,
                  id: "projectSettings",
                  label: "Dashboard",
                  icon: <SettingsOutlinedIcon />,
                  link: "/project-dashboard",
                },
                // {
                //   uniqueId: 19,
                //   id: "project-individual-dashboard",
                //   label: "Startup Dashboard",
                //   link: `/project/${project?.id}/dashboard`,
                //   icon: <DashboardIcon />,
                // },
                // {
                //   uniqueId: 20,
                //   id: "project-detail",
                //   label: "Startup Details",
                //   link: `/project/${project?.id}/details`,
                //   icon: <DashboardOutlinedIcon />,
                // },
                // // ...![ProjectStatuses.DRAFT].includes(currentProjectRole?.project?.status) ? [ {
                // {
                //   uniqueId: 24,
                //   id: "project-kanban-board",
                //   label: "Kanban Board",
                //   link: `/project/${project?.id}/kanban-board`,
                //   icon: <DashboardOutlinedIcon />,
                // },
                {
                  uniqueId: 2,
                  id: "calendar",
                  label: "Calendar",
                  icon: <InsertChartOutlinedOutlinedIcon />,
                  link: `/calendar`,
                },
              ],
            ],
            openItems: [...prev.openItems],
          }));
          break;
        case Role.MENTOR:
          setMenu((prev) => ({
            menu: [
              ...[
                {
                  uniqueId: 1,
                  id: "projectSettings",
                  label: "Home Page",
                  icon: <DashboardOutlinedIcon />,
                  link: `/projects`,
                },
                {
                  uniqueId: 16,
                  id: "agenda",
                  label: "Courses & Agenda",
                  icon: <TodayOutlined />,
                  link: `/to-do-list`,
                },
                // {
                //   uniqueId: 3,
                //   id: "management",
                //   label: props.t("Overview"),
                //   icon: <PostAddOutlinedIcon />,
                //   //link: "/#",
                //   children: [
                //     {
                //       uniqueId: 4,
                //       id: "overview",
                //       label: props.t("Milestone"),
                //       link: "/milestone-overview",
                //       parentId: "management",
                //       icon: <EmojiFlagsIcon />,
                //     },
                //     // {
                //     //   uniqueId: 5,
                //     //   id: "overview",
                //     //   label: "Projects",
                //     //   parentId: "management",
                //     //   icon: <AccountTreeOutlinedIcon />,
                //     //   children: [
                //     //     {
                //     //       id: "ongoingProject",
                //     //       label: "Ongoing Projects",
                //     //       link: `/ongoing-projects`,
                //     //       icon: <ContentPasteGoOutlinedIcon />,
                //     //       parentId: "projects",
                //     //     },
                //     //     {
                //     //       uniqueId: 6,
                //     //       id: "pendingProject",
                //     //       label: "Pending Projects",
                //     //       link: `/pending-projects`,
                //     //       parentId: "projects",
                //     //       icon: <PendingActionsOutlinedIcon />,
                //     //     },
                //     //   ],
                //     // },
                //     {
                //       uniqueId: 7,
                //       id: "overview",
                //       label: props.t("Risk Register"),
                //       link: "/risk-register-overview",
                //       parentId: "management",
                //       icon: <AppRegistrationOutlinedIcon />
                //     },
                //   ],
                // },
                // {
                //   uniqueId: 10,
                //   id: "submission",
                //   label: "Submission",
                //   icon: <AssignmentTurnedInOutlinedIcon />,
                //   children: [
                //     {
                //       uniqueId: 11,
                //       id: "project-submission-done",
                //       label: "Projects",
                //       link: `/project-submission-done`,
                //       parentId: "submission",
                //       icon: <AccountTreeOutlinedIcon />,
                //     },
                //   ],
                // },
                {
                  uniqueId: 2,
                  id: "calendar",
                  label: "Calendar",
                  icon: <ViewAgendaOutlinedIcon />,
                  link: `/calendar`,
                },
                {
                  uniqueId: 31,
                  id: "all-actions",
                  label: "All Actions",
                  icon: <PostAddOutlinedIcon />,
                  link: "/all-actions",
                },
                // {
                //   uniqueId: 12,
                //   id: "userManagement",
                //   label: "User Management",
                //   icon: <PeopleAltOutlinedIcon />,
                //   children: [
                //     {
                //       uniqueId: 13,
                //       id: "user",
                //       label: "User",
                //       link: "/user-list",
                //       parentId: "userManagement",
                //       icon: <PersonOutlineOutlinedIcon/>,
                //     }
                //   ],
                // },
                // {
                //   uniqueId: 14,
                //   id: "apps",
                //   label: "Portfolio",
                //   icon: <ViewQuiltOutlinedIcon />,
                //   link: "/portfolio",
                // },
                {
                  uniqueId: 28,
                  id: "projects",
                  label: "Startup List",
                  icon: <DashboardIcon />,
                  link: "/all-projects",
                },
                {
                  uniqueId: 29,
                  id: "documents",
                  label: "Startup Files",
                  icon: <StickyNote2Icon />,
                  link: "/all-documents",
                },
                // {
                //   uniqueId: 33,
                //   id: "legal-documents",
                //   label: "Legal Documents",
                //   icon: <StickyNote2Icon />,
                //   link: "/legal-documents",
                // },
                {
                  uniqueId: 34,
                  id: "deliverables",
                  label: "Deliverables",
                  icon: <StickyNote2Icon />,
                  link: "/deliverables",
                },
                // {
                //   uniqueId: 17,
                //   id: "strategies",
                //   label: "Strategies",
                //   icon: <LightbulbOutlinedIcon />,
                //   children: [
                //     {
                //       uniqueId: 18,
                //       id: "initiative",
                //       label: "Initiative",
                //       link: "/strategy-list",
                //       parentId: "strategies",
                //       icon: <PsychologyOutlinedIcon />
                //     },
                //     {
                //       id: "kpi",
                //       label: "KPIs",
                //       link: "/",
                //       parentId: "strategies",
                //     }
                //   ],
                // }
              ],
            ],
            openItems: [...prev.openItems],
          }));
          break;

        default:
          setMenu(...initialMenu);
        // {
        //   menu: [...[
        //     {
        //       id: "projectSettings",
        //       label: "Dashboard",
        //       icon: <SettingsOutlinedIcon />,
        //       link: "/project-dashboard",
        //     },
        //     {
        //       id: "project-individual-dashboard",
        //       label: "Project Dashboard",
        //       link: `/project/${project?.id}/dashboard`,
        //       icon: <DashboardIcon />
        //     },
        //     {
        //       id: "project-detail",
        //       label: "Project Details",
        //       link: `/project/${project?.id}/details`,
        //       icon: <DashboardOutlinedIcon />,
        //     },
        //     {
        //       id: "approval",
        //       label: "Approvals",
        //       icon: <ApprovalIcon />,
        //       children: [
        //         {
        //           id: "project-approval",
        //           label: "Projects",
        //           link: `/project/${project?.id}/project-approval`,
        //           parentId: "approval",
        //           icon: <AccountTreeOutlinedIcon/>
        //         },
        //         {
        //           id: "change-request-approval",
        //           label: "Change Request",
        //           link: `/project/${project?.id}/change-request-approval`,
        //           parentId: "approval",
        //           icon: <ChangeCircleOutlinedIcon/>
        //         },
        //       ],
        //     },
        //     {
        //       id: "submission",
        //       label: "Submission",
        //       icon: <DoneAllIcon />,
        //       children: [
        //         {
        //           id: "project-submission-done",
        //           label: "Projects",
        //           link: `/project/${project?.id}/project-submission-done`,
        //           parentId: "submission",
        //           icon: <AccountTreeOutlinedIcon/>
        //         }
        //       ],
        //     },
        //     {
        //       id: "agenda",
        //       label: "Agenda",
        //       icon: <InsertChartOutlinedOutlinedIcon />,
        //       link: `/to-do-list`,
        //     },
        //   ]],
        //   openItems: []
        // }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentProjectRole, localStorage.getItem("I18N_LANGUAGE")]);

  useEffect(() => {
    if (menu.menu.length) {
      setLogoLink(menu.menu[0].link);
    }
  }, [menu]);

  const drawerWidth = 240;

  const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
  });

  const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(${theme.spacing(8)} + 1px)`,
    },
  });

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  }));
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const RecursiveList = ({ items, depth = 0 }) => {
    const navigate = useNavigate();

    const handleNavigation = (item, isOpened) => {
      // console.log('go there', link)
      if (item?.link) {
        navigate(item?.link);
        setSelectUniqueId();
      }
    };

    const handleToggle = (itemPassed) => {
      setMenu((prevState) => {
        const itemIsOpened = prevState.openItems.includes(itemPassed.uniqueId);

        if (recursiveChildrenActiveLink(itemPassed)) {
          setSelectUniqueId();
        } else {
          setSelectUniqueId(itemPassed.uniqueId);
        }

        handleNavigation(itemPassed, itemIsOpened);
        const updatedOpenItems = itemIsOpened
          ? prevState.openItems.filter((item) => item !== itemPassed.uniqueId)
          : [...prevState.openItems, itemPassed.uniqueId];

        return {
          ...prevState,
          openItems: [...updatedOpenItems],
        };
      });
    };

    return (
      <List className="sidebarItems">
        {items.menu.map((item) => (
          item &&
          <React.Fragment key={item.label}>
            <ListItem
              className={`nav-item d-flex flex-column align-items-start ${recursiveChildrenActive(item) ? "active-nav-item" : ""
                }`}
            >
              <ListItemButton onClick={() => handleToggle(item)}>
                <div className="nav-link menu-link d-flex align-items-center justify-content-between w-100">
                  <ListItemIcon>{item?.icon}</ListItemIcon>
                  <ListItemText primary={props.t(item?.label)} />
                  {item?.children &&
                    (items?.openItems.includes(item?.label) ? (
                      <ExpandLess className="sm_ico" />
                    ) : (
                      <ExpandMore className="sm_ico" />
                    ))}
                </div>
              </ListItemButton>
              {item?.children?.length > 0 && (
                <Collapse
                  in={items?.openItems.includes(item?.uniqueId)}
                  timeout="auto"
                  unmountOnExit
                  style={{ width: "100%" }}
                >
                  <List className="p-0 child-padding">
                    {item.children.map((child) => (
                      child &&
                      <React.Fragment key={child.label}>
                        {child?.label && (
                          <ListItem
                            disablePadding
                            className={`nav-item ${recursiveChildrenActive(child)
                              ? "active-nav-innerItem"
                              : ""
                              }`}
                          >
                            <ListItemButton
                              className="w-100"
                              onClick={() => handleToggle(child)}
                            >
                              <div className="nav-link menu-link d-flex align-items-center justify-content-between w-100">
                                <ListItemIcon>{child.icon}</ListItemIcon>
                                <ListItemText primary={props.t(child.label)} />
                                {child.children &&
                                  (items.openItems.includes(child.uniqueId) ? (
                                    <ExpandLess className="sm_ico" />
                                  ) : (
                                    <ExpandMore className="sm_ico" />
                                  ))}
                              </div>
                            </ListItemButton>
                          </ListItem>
                        )}
                        {child.children?.length > 0 && (
                          <Collapse
                            in={items.openItems.includes(child.uniqueId)}
                            timeout="auto"
                            unmountOnExit
                          >
                            <List className="p-0 w-100">
                              {child.children.map((subChild) => (
                                <ListItem
                                  key={subChild.label}
                                  disablePadding
                                  className={`nav-item ${recursiveChildrenActive(subChild)
                                    ? "active-nav-innerItem w-100"
                                    : ""
                                    }`}
                                >
                                  <ListItemButton
                                    onClick={() => handleToggle(subChild)}
                                  >
                                    <div className="nav-link menu-link d-flex align-items-center justify-content-between w-100">
                                      <ListItemIcon>
                                        {subChild.icon}
                                      </ListItemIcon>
                                      <ListItemText
                                        primary={props.t(subChild.label)}
                                      />
                                    </div>
                                  </ListItemButton>
                                </ListItem>
                              ))}
                            </List>
                          </Collapse>
                        )}
                      </React.Fragment>
                    ))}
                  </List>
                </Collapse>
              )}
            </ListItem>
          </React.Fragment>
        ))}
      </List>
    );
  };

  return (
    <React.Fragment>
      <Drawer
        sx={{
          zIndex: 1003,
        }}
        variant="permanent"
        className={`${props?.isCollapsed ? "collapsed-sidebar" : "openSidebar"
          }`}
      >
        <Divider />
        <div className={`app-menu navbar-menu customSidebar sidebar`}>
          <div className="navbar-brand-box my-1">
            <Link to={logoLink} className="logo">
              <img
                src={
                  props?.isCollapsed
                    ? stageminiLogo : stageLogo
                }
                alt="Logo"
                className="logo_size"
              />
              {/* src={props?.isCollapsed ? (matchStageEnv.test(process.env.REACT_APP_API_URL) ? stageminLogo : devminiLogo)  : (matchStageEnv.test(process.env.REACT_APP_API_URL) ? stageLogo : devLogo)} */}
              {/* <img src={props?.isCollapsed ? CaspMiniLogo : mainLogo} alt="Logo" /> */}
            </Link>
            {miniVariant && (
              <IconButton onClick={handleDrawerClose}>
                <ChevronRightIcon />
              </IconButton>
            )}
          </div>
          <div id="scrollbar" className="h-100 scrollable_sidebar">
            <RecursiveList items={menu} />
          </div>
        </div>
      </Drawer>
      <IconButton
        onClick={toggleMiniVariant}
        sx={{
          position: "fixed",
          top: "50%",
          transform: "translateY(-50%)",
          left: miniVariant ? theme.spacing(7) : 0,
          display: miniVariant ? "block" : "none",
        }}
      >
        <ChevronRightIcon />
      </IconButton>
    </React.Fragment>
  );
};

MainSidebar.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(MainSidebar));
